import {
  Component,
  effect,
  input,
  OnInit,
  signal,
  ViewChild,
} from '@angular/core';
import {
  ChartComponent,
  ApexAxisChartSeries,
  ApexChart,
  ApexXAxis,
  ApexTitleSubtitle,
} from 'ng-apexcharts';
import { GraphApiService, SupervisorApiService } from '../../core/api/services';
import {
  PatientProgramModel,
  PatientSessionEntryModel,
} from '../../core/api/models';
import { MultiSelect, MultiSelectChangeEvent } from 'primeng/multiselect';
import { Router } from '@angular/router';
import { SelectItem } from 'primeng/api';
import { PatientDataFacadeService } from '../../core/services/patient-data-facade.service';
type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  xaxis: ApexXAxis;
  title: ApexTitleSubtitle;
};

@Component({
  selector: 'app-programs',
  templateUrl: './programs.component.html',
  styleUrl: './programs.component.css',
  standalone: false,
})
export class ProgramsComponent {
  patientID = input.required<string>();

  isLoading: boolean = false;

  selectablePrograms = signal<SelectItem[]>([]);
  selectedProgram: PatientProgramModel | null = null;

  constructor(
    private supervisorApiService: SupervisorApiService,
    private router: Router,
    private patientDataFacade: PatientDataFacadeService
  ) {
    effect(() => {
      if (this.patientID()) {
        this.loadData();
      } else {
        this.router.navigate(['/select-patient']);
      }
    });
  }

  loadData() {
    this.isLoading = true;
    this.patientDataFacade.getPrograms(Number(this.patientID()), { onlyActive: false })
    .subscribe(
      (programs) => {
        console.log('programs', programs);
        this.selectablePrograms.set(
          // filter out deleted programs
          programs
            .filter((program) => !program.IsDeleted)
            .map((program) => ({ label: program.ProgramName ?? 'No Name', value: program }))
        );
        console.log('selectablePrograms', this.selectablePrograms());
        this.isLoading = false;
      },
      (error) => {
        console.error('Error fetching programs', error);
        this.isLoading = false;
      }
      );
  }

  onProgramsChange(event: MultiSelectChangeEvent) {
    if (!event.value) {
      return;
    }
  }
}
